var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible())?_c('li',{staticClass:"ce-sub-nav-item"},[_c('a',{attrs:{"href":_vm.href,"title":_vm.title},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.text))]),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }